module.exports = __webpack_public_path__ + "static/media/art73.e8064f17.jpg";